var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskListGorrionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 67,
    viewBox: "0 0 118 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8013 63.3246C67.2561 62.9893 52.0343 62.2732 49.3323 62.0942C45.9742 61.8728 43.0643 55.1511 42.8759 47.6384C42.5252 33.5505 42.2524 19.3064 49.3647 12.9525C56.987 6.13966 64.2001 5.25429 77.0868 5.36496C88.0282 5.4561 99.4308 6.65071 106.296 14.9934C111.999 21.9202 111.613 37.1799 110.801 45.6561C109.83 55.7859 107.865 62.9144 104.293 63.1846C100.72 63.4515 90.4607 63.7282 77.8013 63.3246Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5889 5.49524C83.5889 5.49524 85.9499 3.86771 86.3007 2.78703C86.6514 1.70635 86.4858 1 86.4858 1",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8198 5.31303C85.8198 5.31303 86.6025 4.32675 88.0964 3.38278C88.8694 2.89452 89.8015 2.73828 89.8015 2.73828",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0557 20.8428L117 21.9593",
    stroke: "black",
    strokeWidth: 1.62595,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9072 17.5879L76.122 20.843",
    stroke: "black",
    strokeWidth: 1.62595,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.815 21.9199L114.993 35.9232L84.501 34.4096",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4908 33.5507L38.9722 31.6921L39.9075 17.5879",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.115 21.5623C60.8682 23.1052 58.6403 24.5733 56.0519 24.3389C53.4635 24.1045 51.5929 22.2654 51.7455 20.7095C52.0053 18.0469 54.2008 18.5449 56.7892 18.7825C59.3775 19.0201 61.5275 18.9843 61.115 21.5623Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.24 23.7269C103.993 25.2698 101.765 26.7378 99.1769 26.5034C96.5885 26.2691 94.7179 24.43 94.8705 22.8741C95.1303 20.2114 97.3258 20.7094 99.9142 20.9471C102.499 21.1814 104.656 21.1489 104.24 23.7269Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3633 26.8647C78.1259 26.6303 76.0701 26.5457 74.4073 27.047C73.0823 27.4441 72.2769 28.209 72.2769 28.209C74.2514 35.6175 77.4959 37.2744 77.4959 37.2744C77.4959 37.2744 83.0559 33.5506 82.6986 28.9251",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2236 62.7451C56.2236 62.7451 57.0485 64.913 58.799 65.2222C60.5495 65.5314 65.0313 65.6617 66.6779 65.3264C68.0322 65.0497 68.5225 63.1813 68.5225 63.1813",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3921 63.7383C88.3921 63.7383 88.9604 65.4374 90.7109 65.7499C92.4614 66.0591 96.9432 66.1014 98.5898 65.7662C99.944 65.4895 100.509 63.5332 100.509 63.5332",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.626 22.0189C20.626 22.0189 10.4317 14.6262 6.98105 10.1505C5.76317 8.44159 5.84437 4.65753 7.87413 4.21011C13.7606 9.41805 24.7381 18.4169 27.3039 19.6105L27.5372 23.7365L20.626 22.0189Z",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3786 20.5491C17.3786 20.5491 15.8292 20.5441 14.556 23.338C14.0699 24.3406 13.9485 25.4818 14.2127 26.5646C14.2127 26.5646 16.1739 26.0017 20.6245 26.5621C22.5577 26.7805 24.4709 27.1496 26.3467 27.6663C28.9357 27.9849 31.2017 24.7007 31.2017 24.7007C31.2017 24.7007 24.3554 22.9203 21.3933 22.2545C18.7139 21.6726 17.3786 20.5491 17.3786 20.5491Z",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5722 27.2263C14.4033 27.5767 14.3234 27.9635 14.3397 28.3524C14.356 28.7412 14.468 29.12 14.6656 29.455C15.7696 31.3243 17.1223 31.9421 17.1223 31.9421C21.0746 29.6016 25.4108 30.2063 25.4108 30.2063C25.4108 30.2063 28.334 29.2935 27.6742 28.0779L26.357 27.673C26.357 27.673 17.3518 25.1066 14.5722 27.2263Z",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0842 15.7974C32.382 15.6277 31.6986 15.3879 31.0442 15.0815C30.3455 14.7254 29.6793 14.3086 29.0532 13.836C26.8351 17.802 25.2184 22.8954 24.3113 26.9371C24.8 27.0354 25.3039 27.03 25.7904 26.9214C26.2769 26.8127 26.7353 26.6031 27.1361 26.3061C31.3277 23.0538 33.7939 16.551 33.0842 15.7974Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.975572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.598 31.0118C20.9599 33.7808 24.2578 36.8246 28.574 39.8313C32.8703 42.8241 38.1041 45.7323 43.2466 48.2485L42.8178 49.1248C37.649 46.5957 32.3677 43.6629 28.0163 40.6318C23.6848 37.6144 20.2024 34.451 18.7226 31.4423L19.598 31.0118Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2545 17.7036C33.6013 18.5899 34.3971 19.3211 35.4832 19.9165C36.5638 20.5089 37.8769 20.9365 39.1645 21.2416C40.4485 21.5458 41.6861 21.7236 42.6045 21.8252C43.0631 21.8759 43.4406 21.9075 43.7026 21.9263C43.8336 21.9357 43.9356 21.942 44.0044 21.9458C44.0387 21.9478 44.0648 21.9491 44.082 21.9499C44.0906 21.9504 44.097 21.9507 44.1011 21.9508C44.1031 21.9509 44.1046 21.951 44.1055 21.951C44.106 21.9511 44.1063 21.9511 44.1064 21.9511C44.1065 21.9511 44.1065 21.9511 44.1066 21.9511C44.1065 21.9511 44.1065 21.9511 44.0859 22.4384C44.0654 22.9258 44.0653 22.9258 44.0651 22.9258C44.065 22.9258 44.0648 22.9258 44.0646 22.9258C44.0641 22.9257 44.0636 22.9257 44.0628 22.9257C44.0614 22.9256 44.0594 22.9255 44.0568 22.9254C44.0516 22.9252 44.0441 22.9248 44.0343 22.9243C44.0149 22.9234 43.9865 22.9219 43.9497 22.9199C43.8761 22.9157 43.769 22.9092 43.6326 22.8994C43.3599 22.8798 42.9699 22.8471 42.4973 22.7948C41.5534 22.6904 40.274 22.5071 38.9396 22.1909C37.6087 21.8755 36.2019 21.4231 35.0142 20.772C33.8321 20.1239 32.8112 19.2479 32.346 18.0591L33.2545 17.7036Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskListGorrionIcon);
export default __webpack_public_path__ + "static/media/taskListGorrionIcon.50e049d3b78ea3ca0523ba038d659201.svg";
export { ForwardRef as ReactComponent };